// useDirectUpload Hook - React Hook for Direct Upload
import { useState, useCallback } from 'react';
import directUploadService from '../services/directUpload';

export const useDirectUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [uploadInfo, setUploadInfo] = useState(null);

  const resetUpload = useCallback(() => {
    setUploading(false);
    setProgress(0);
    setError(null);
    setUploadInfo(null);
  }, []);

  const uploadVideo = useCallback(async (file, lessonData, thumbnailFile = null) => {
    try {
      resetUpload();
      setUploading(true);

      const validation = directUploadService.validateFile(file);
      if (!validation.isValid) {
        throw new Error(validation.errors.join(', '));
      }

      // Start upload with progress tracking and thumbnail
      const result = await directUploadService.completeDirectUpload(
        file,
        lessonData,
        thumbnailFile,
        (percentComplete) => {
          setProgress(percentComplete);
        }
      );

      setUploadInfo(result?.uploadInfo);
      setUploading(false);

      return result;

    } catch (err) {
      // Direct upload error handling

      const errorMessage =
        err?.message ||
        err?.response?.data?.error ||
        'فشل في رفع الفيديو';

      setError(errorMessage);
      setUploading(false);

      throw err;
    }
  }, [resetUpload]);

  const cancelUpload = useCallback(async (lessonId) => {
    try {
      await directUploadService.cancelUpload(lessonId);
      resetUpload();
    } catch (err) {
      // Direct upload cancel error handling
      const errorMessage = err?.message || err?.response?.data?.error || 'فشل في إلغاء الرفع';
      setError(errorMessage);
      throw err;
    }
  }, [resetUpload]);

  return {
    uploadVideo,
    cancelUpload,
    resetUpload,
    uploading,
    progress,
    error,
    uploadInfo
  };
};
